import { Box, Button, Modal } from "@mui/material";
import { Client, User, UserRoles } from "../../types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Input } from "../../hookFormComponents.tsx/Input";
import { api } from "../../api/api";

type Props = {
  modalConfig: { open: boolean; data: Client };
  handleClose: () => void;
  fetcher: () => Promise<void>;
  setModalConfig: React.Dispatch<
    React.SetStateAction<
      | {
          data?: Client;
          open: boolean;
        }
      | undefined
    >
  >;
};

function CreateModalClients({
  modalConfig,
  handleClose,
  fetcher,
  setModalConfig,
}: Props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "white",
    boxShadow: 24,
    borderRadius: "10px",
    p: 4,
  };

  const validationSchema1 = Yup.object({
    email: Yup.string().required("Required").email("Invalid Email"),
    password: Yup.string().required("Required").min(6, "Minumum 6 characters"),
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    phone: Yup.number().required("Required"),
    title: Yup.string().required("Required"),
    text: Yup.string().required("Required"),
    fcm: Yup.string().required("Required"),



   
  });

  const validationSchema2 = Yup.object({
    email: Yup.string().required("Required").email("Invalid Email"),
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    phone: Yup.number().required("Required"),
    title: Yup.string().required("Required"),
    text: Yup.string().required("Required"),
    fcm: Yup.string().required("Required"),



  
  });

  const {
    formState: { errors },
    control,
    setValue,
    register,
    handleSubmit,
    getValues,
  } = useForm<
    Yup.InferType<typeof validationSchema1 | typeof validationSchema2>
  >({
    resolver: yupResolver(
      !modalConfig.data ? validationSchema1 : validationSchema2
    ),
    defaultValues: modalConfig.data
      ? {
          email: modalConfig.data.email,
          first_name: modalConfig.data.first_name,
          last_name: modalConfig.data.last_name,
          phone: modalConfig.data.phone,
          fcm: modalConfig.data.fcm_token,
          title:"",
          text:""
       
        
        } : {}
     
  });
  const handleFcm = async()=>{
    const values = getValues();  
    const { title, text,fcm } = values;  
   
   
 
    const data={
      deviceToken:fcm,
      title: title,
      body: text
    }
    
    api
    .post(`/auth/send_push`,data )
    .then((res) => {
      fetcher();
      setModalConfig((prev) => ({
        data: undefined,
        open: false,
      }));
    })
    .catch((e) => console.log(e));
  }

  return (
    <Modal open={modalConfig.open} onClose={handleClose}>
      <Box sx={style}>
        <form
          noValidate
          onSubmit={handleSubmit((values) => {
            if (modalConfig.data) {
              api
                .post(`/client/${modalConfig.data.id}/update`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            } else {
              api
                .post(`/auth/register`, values)
                .then((res) => {
                  fetcher();
                  setModalConfig((prev) => ({
                    data: undefined,
                    open: false,
                  }));
                })
                .catch((e) => console.log(e));
            }
          })}
        >

      {/* <div >
      <label>
        Tittle
        </label>
        <input />
      </div>
      <div >
      <label>
        Text
        </label>
        <input />
      </div> */}
     
          <Input
            required
            {...register("title")}
            label={"Title"}
            type="text"
            error={errors?.phone?.message}
          />
             <Input
            required
            {...register("text")}
            label={"Text"}
            type="text"
            error={errors?.phone?.message}
          />
       
          <Box sx={{ display: "flex", justifyContent: "right" }}>
            <button onClick={handleFcm} type="submit" >
              Submit
            </button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default CreateModalClients;
